import { Collapse, TableCell, TableRow } from '@mui/material'
import React from 'react'

const InnerTable = ({ open, children }) => {
  return (
    <>
        <TableRow></TableRow>
        <TableRow data-subrow="true" className='innerTable' >
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={'100%'}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    {children}
                </Collapse>
            </TableCell>
        </TableRow>
    </>
  )
}

export default InnerTable